import { ReactNode } from 'react'

import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'

import { HeroCtaContainer } from './HeroCtaContainer'
import { HeroTitle, HeroTitleTypography } from './HeroTitleTypography'
import {
  HeroRebrandLayout,
  HeroRebrandLayoutProps
} from './layouts/HeroRebrandLayout'
import { PatternBackground, SolidBackground } from './types'

type ShortHeroRebrandProps = {
  title: HeroTitle
  eyebrow?: string
  intro?: string
  ctas?: ReactNode
  mode?: HeroRebrandLayoutProps['mode']
  unified?: boolean
  darkHeader?: boolean
} & (SolidBackground | PatternBackground)

const ShortHeroRebrand = (props: ShortHeroRebrandProps) => {
  const {
    eyebrow,
    title,
    intro,
    ctas,
    mode,
    unified,
    layout,
    pattern,
    color,
    darkHeader
  } = props

  return (
    <HeroRebrandLayout
      darkHeader={darkHeader}
      mode={mode}
      {...(layout === 'solid' ? { layout, color } : { layout, pattern })}
      unified={unified}
    >
      <div className='hero-text-content flex-1 flex flex-col justify-center items-center text-center py-10 md:py-25'>
        {eyebrow ? (
          <TypographyRebrand variant='eyebrow'>{eyebrow}</TypographyRebrand>
        ) : null}
        <HeroTitleTypography title={title} variant='h1' />
        {intro ? (
          <TypographyRebrand variant='introduction'>{intro}</TypographyRebrand>
        ) : null}
        {ctas ? <HeroCtaContainer>{ctas}</HeroCtaContainer> : null}
      </div>
    </HeroRebrandLayout>
  )
}

export default ShortHeroRebrand
